import { PropsWithChildren } from "react";

import { cn } from "@/lib/cn";
import { Row, type RowData } from "@tanstack/react-table";

interface DatatableCellNumberProps<TData extends RowData> extends PropsWithChildren {
  row: Row<TData>;
  className?: string;
}

export const DatatableCellNumber = <TData extends RowData>({
  children,
  className,
}: DatatableCellNumberProps<TData>) => {
  return (
    <div className={cn(["relative flex h-full flex-row items-center justify-start gap-1 font-normal", className])}>
      {children}
    </div>
  );
};
